"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigurationProviderManager = void 0;
/**
 * Class to manage {@link I18nConfigurationProvider} access.
 *
 * This class is designed so that the I18nConfigurationProvider only has to be
 * registered once within an application, and after that the same
 * I18nConfigurationProvider interface is used to retrieve configurations.
 */
class ConfigurationProviderManager {
    constructor(_provider) {
        this._provider = _provider;
    }
    /**
     * Registers the specified Configuration Provider. If a provider was already
     * registered this request is being ignored.
     *
     * @param provider  {@link I18nConfigurationProvider} implementation to use for
     *                  configuration retrieval.
     */
    static register(provider) {
        if (provider === undefined || provider === null) {
            throw new Error('Configuration provider cannot be undefined or null');
        }
        if (this.instance === undefined) {
            this._instance = new ConfigurationProviderManager(provider);
            console.log(`Registered provider ${provider.constructor.name} for configuration resolution.`);
        }
        else {
            console.warn(`Provider ${this.instance._provider.constructor.name} is already registered. `
                + `Ignoring register request for ${provider.constructor.name}`);
        }
    }
    /**
     * Accessor to the registered {@link I18nConfigurationProvider} instance to be
     * used for configuration retrieval.
     *
     * @return registered {@link I18nConfigurationProvider} instance
     */
    static getProvider() {
        if (this.instance !== undefined) {
            return this.instance._provider;
        }
        else {
            console.warn('No provider has been registered yet. Returning undefined.');
        }
        return undefined;
    }
    /**
     * Check whether a {@link I18nConfigurationProvider} has been registered.
     *
     * @return true if the {@link I18nConfigurationProvider} has been registered. Otherwise, false.
     */
    static hasProvider() {
        return this.instance != undefined;
    }
    static get instance() {
        return this._instance;
    }
    static resetInstance() {
        this._instance = undefined;
    }
}
exports.ConfigurationProviderManager = ConfigurationProviderManager;
//# sourceMappingURL=configuration-provider-manager.js.map